<p-dialog id="searchclient"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '60vw', height: '60vh'}"
          >
  <ng-template pTemplate="content">
      <div class="grid formgrid">
        <div class="fluid col mt-6 mb-4">
            <span class="p-float-label">
              <input id="smtng-input" type="text" (keyup)="onKeyPress($event)" pInputText [(ngModel)]="something">
              <label for="float-input">Что нибудь...</label>
            </span>
        </div>
      </div>

      <div class="grid">
        <div class="col-12">
            <p-table [value]="companies"
                     [loading]="loading"
                     [rows]="rows"
                     styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
                     dataKey="CLIHASH"
                     [paginator]="true"
                     selectionMode="single"
                     [(selection)]="selection"
                     [rowHover]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 25%">Компания </th>
                  <th style="width: 20%">Контакт </th>
                  <th style="width: 10%">Город </th>
                  <th style="width: 10%">Телефон </th>
                  <th style="width: 20%">E-mail </th>
                  <th style="width: 15%">Группа </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-companies>
                <tr [pSelectableRow]="companies">
                  <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                    <a [routerLink]="['/edit-client', companies.CLIID]">{{companies.CLIENTSNIKNAME}}</a>
                  </td>
                  <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.PERSONFNAME}} {{companies.PERSONLNAME}}</td>
                  <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.CLIENTCITY}}</td>
                  <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.PERSONCPHONE}}</td>
                  <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.PERSONEMAIL}}</td>
                  <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.CASTCATNAME}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="6">Пока ничего не найдено...</td>
                </tr>
              </ng-template>
            </p-table>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button label="ОК!" (click)="onConfirm('ok')" [disabled]="!thereIsSelection"></p-button>
      <p-button label="Отмена" (click)="display=false"></p-button>
    </ng-template>
    </p-dialog>
